import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const AttentiveScript = () => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {attentive} = commerceAPI
    const {config} = attentive || {}

    var attentiveScriptTagURL = null
    var attentiveScriptLoadURL = null

    try {
        const jsonConfig = JSON.parse(config)
        if (jsonConfig) {
            attentiveScriptTagURL = jsonConfig.scriptTagURL
            attentiveScriptLoadURL = jsonConfig.scriptLoadURL
        }
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (attentiveScriptTagURL || attentiveScriptLoadURL) {
            // Check if script is already added
            const existingScript = document.querySelector(`script[src="${attentiveScriptLoadURL}"]`)

            if (!existingScript) {
                const script = document.createElement('script')
                script.src = attentiveScriptLoadURL
                script.async = true
                script.defer = true
                script.type = 'text/javascript'
                script.onError = `var fallbackScript = document.createElement("script"); fallbackScript.src="${attentiveScriptTagURL}"; document.head.appendChild(fallbackScript);`

                document.body.appendChild(script)
            }
        }
    }, [attentiveScriptTagURL, attentiveScriptLoadURL])

    return null
}

export default AttentiveScript
